import { isNil } from 'lodash';
import { useCallback, useContext } from 'react';
import { StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { FileUpload } from '@shared/components/blocks/types';
import { MBIconV2 } from '@shared/components/image';
import { Pill } from '@shared/components/pill';
import { HoverTooltip } from '@shared/components/tooltip';
import { TruncateMiddle } from '@shared/components/truncate';
import { ColorThemeContext, grid } from '@shared/styles';
import { MBLinking } from '@shared/util/linking';
import { getFilenameParts } from '@shared/util/media/type';

interface Props {
  file: FileUpload;
  style?: StyleProp<ViewStyle>;
  editable: boolean;
  showFileIcon?: boolean;
  onClear?: () => void;
}

export function FileItem({ file, onClear, editable, style, showFileIcon = true }: Props) {
  const colors = useContext(ColorThemeContext);
  const openFile = useCallback(() => MBLinking.open(file.url), [file.url]);
  const [filename, extension] = getFilenameParts(file.name);
  const end = extension ? `.${extension}` : undefined;

  if (isNil(file)) {
    return null;
  }

  return (
    <HoverTooltip tooltip={file.name}>
      <Pill
        noLeftMargin
        onPress={openFile}
        onRemove={editable ? onClear : undefined}
        maxWidth={grid(30)}
        style={[{ marginRight: grid(1) }, style]}
      >
        {showFileIcon && (
          <MBIconV2
            name="file"
            color={colors.foregroundActive}
            size={grid(3)}
            style={{ marginRight: grid(1) }}
          />
        )}
        <TruncateMiddle beginning={filename} end={end} style={styles.filename} />
      </Pill>
    </HoverTooltip>
  );
}

const styles = StyleSheet.create({
  filename: {
    flexShrink: 1,
  },
});
